(function (){
  
  //Resets the button - fixes a safari bug when the user clicks the back button
  const resetButton = () => {
    if (FS.Browser.getMake() === "safari") {
      const submitButtonEl = document.getElementById('submitFormBtn');
      if (submitButtonEl && submitButtonEl.classList.contains('fs-button--loading')) {
        submitButtonEl.classList.remove('fs-button--loading');
      }
    }
  }
  window.addEventListener('beforeunload',resetButton);

  const surnameOnlyView = window.discoveryFormData.surnameOnlyView;
  const deathBeforeBirthValidation = window.discoveryFormData.deathBeforeBirthValidation;
  if (surnameOnlyView) {
    const surnameFieldEl = document.getElementById('surnameField');
    const surnameOnlyFieldContainerEl = document.getElementById('surnameOnlyFieldContainer');
    const surnameFullFormContainerEl = document.getElementById('surnameFullFormContainer');
    surnameOnlyFieldContainerEl.insertBefore(surnameFieldEl, null);

    const searchSpecificAncestorLink = window.discoveryFormData.searchSpecificAncestorLink;
    const showLessLink = window.discoveryFormData.showLessLink;
    const lastNameFieldTitle = window.discoveryFormData.lastNameFieldTitle;
    const lastNameFieldTitleAlt = window.discoveryFormData.lastNameFieldTitleAlt;

    const toggleFormLinkEl = document.getElementsByClassName('toggleFormLink')[0];
    const surnameOnlyFormEl = document.getElementsByClassName('formItem')[0];
    const fullFormEl = document.getElementsByClassName('fullForm')[0];
    const toggleFormTextEl = document.getElementById('toggleFormText');
    const lastNameLabelEl = document.getElementById('lastNameLabel');

    let surnameOnlyMode = true;

    const handleFormToggle = () => {
      surnameOnlyFormEl.classList.toggle('hidden');
      fullFormEl.classList.toggle('hidden');
      toggleFormLinkEl.classList.toggle('marginLeft');
      if (!surnameOnlyMode) {
        HF.jsLoaded.then(() =>{
          FS.Analytics.trackValue('NLIDiscoveryForm:ShowLess:clicked');
        });
        surnameOnlyFieldContainerEl.insertBefore(surnameFieldEl, null);
        toggleFormTextEl.innerHTML = searchSpecificAncestorLink;
        lastNameLabelEl.innerHTML = lastNameFieldTitleAlt;
      } else {
        HF.jsLoaded.then(() =>{
          FS.Analytics.trackValue('NLIDiscoveryForm:SearchSpecificAncestor:clicked');
        });
        surnameFullFormContainerEl.insertBefore(surnameFieldEl, null);
        toggleFormTextEl.innerHTML = showLessLink;
        lastNameLabelEl.innerHTML = lastNameFieldTitle;
      }
      surnameOnlyMode = !surnameOnlyMode;
    }

    toggleFormLinkEl.addEventListener('click', handleFormToggle);
    toggleFormLinkEl.addEventListener('keypress', handleFormToggle);
  }

  const checkValidDeathYear = () => {
    const birthYearEl = document.getElementById('birthYear');
    const birthVal = birthYearEl.value;
    const deathYearEl = document.getElementById('deathYear');
    const deathVal = deathYearEl.value;
    if (birthVal && deathVal && birthVal > deathVal) {
      deathYearEl.setCustomValidity(deathBeforeBirthValidation);
    } else {
      deathYearEl.setCustomValidity('');
    }
  };

  document.getElementById('birthYear').addEventListener('change', checkValidDeathYear);
  document.getElementById('deathYear').addEventListener('change', checkValidDeathYear);

  const handleFormSubmitButton = event => {
    const formEl = document.getElementById('discoveryForm');
    if (!formEl.checkValidity()) return;
    const submitButtonEl = document.getElementById('submitFormBtn');
    if (submitButtonEl.classList.contains('fs-button--loading')) {
      event.preventDefault();
    } else {
      submitButtonEl.classList.add('fs-button--loading');
    }
  }

  document.getElementById('submitFormBtn').addEventListener('click', handleFormSubmitButton);
}());
